import download from "downloadjs";
import domToImage from "dom-to-image";

export const HIDE_ON_EXPORT = "hide-on-export";

// TODO explore scroll fix : https://github.com/tsayen/dom-to-image/pull/142/files
async function downloadPage(domElement: HTMLElement) {
  const blob = await domToImage.toBlob(domElement, {
    bgcolor: "white",
    filter: domNode =>
      domNode instanceof HTMLElement ? !domNode.classList.contains(HIDE_ON_EXPORT) : true,
  });

  const fileName = `metroscope-${window.location.pathname}-${new Date().toJSON()}.png`;
  download(blob, fileName);
}

export default downloadPage;
